import { VariantProps, cva } from 'class-variance-authority';
import type { CommonProps } from '../../types';
import { twMerge } from 'tailwind-merge';
import { FormEvent } from 'react';

export interface FormProps
    extends CommonProps,
        VariantProps<typeof FormStyles> {
    children: React.ReactNode;
    onSubmit?: (event: FormEvent) => void;
}

export const FormStyles = cva('relative w-full');

export const Form = ({
    children,
    className,
    testId = 'form',
    onSubmit,
    ...props
}: FormProps): JSX.Element => {
    return (
        <form
            className={twMerge(FormStyles({ className }))}
            {...props}
            data-testid={testId}
            onSubmit={onSubmit}
        >
            {children}
        </form>
    );
};
